/**
 * Browser utilities that can be mocked in tests
 */

/**
 * Reloads the current page
 */
export const reloadPage = (): void => {
  document.location.reload();
};
